import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, useFormikContext } from 'formik';

import { createYearList } from '../../../helpers/commonHelper';
import { IsMobile } from '../../../helpers/IsMobile';
import CustomSelect from '../CustomSelect/CustomSelect';

const StartEndYearFields = () => {
  const { t } = useTranslation('common');
  const [startYearList, setStartYearList] = useState(createYearList);
  const [endYearList, setEndYearList] = useState(createYearList);
  const { values } = useFormikContext();
  const modalFullScreen = IsMobile();

  useEffect(() => {
    if (values.start_year) {
      const year = new Date().getFullYear();
      setEndYearList(createYearList(year - values.start_year + 1, year));
    }
  }, [values.start_year]);

  useEffect(() => {
    if (values.end_year) {
      setStartYearList(createYearList(30, values.end_year));
    }
  }, [values.end_year]);

  return (
    <div className="row">
      <div className={modalFullScreen ? '' : 'col'}>
        <Field
          name="start_year"
          as={CustomSelect}
          placeholder={t('placeholders.startYear')}
          options={startYearList}
          data={values.start_year}
          disabled={false}
          clearable
        />
      </div>
      <div className="col">
        <Field
          name="end_year"
          as={CustomSelect}
          placeholder={t('placeholders.endYear')}
          disabled={values.current_position}
          options={endYearList}
          data={values.end_year}
          clearable
        />
      </div>
    </div>
  );
};

export default StartEndYearFields;
